/**
 * internal dependencies
 */
import { IPinPool } from '../../../../../models/cardgroup.interface';
import { COMMON_FORM_ELEMENTS, PIN_POOL_ACTIONS } from "./pin-pool-types";
import { PinPoolModalDisplay } from '../modals/pin-pool-modal';
import WarningModalControl from '../modals/warning-modal';

import PostPinPool from '../../../../../routes/post-pin-pool';
import { showToast } from '../../../../toasts';

/**
 * Check if the user Pin Pool checkbox is checked.  If it is, then
 * enable the Pin Pool fields.  If it is not, then disable the Pin Pool fields.
 * 
 * @param {HTMLInputElement} pinPoolCheckBox - the checkbox element
 * 
 * @returns void 
 */
export const usePinPool = async (pinPoolCheckBox: HTMLInputElement, data: IPinPool, askFor: number) => { 
  const { pinPool: { hasPinPool, pins }, cardGroup } = data.body;
  if ( COMMON_FORM_ELEMENTS.ceAddPinNumber.classList.contains('aafp_display-none') ) {
    COMMON_FORM_ELEMENTS.ceOptional.forEach(field => {
      field.classList.remove('aafp_pin-disabled');
    });
  }

  COMMON_FORM_ELEMENTS.ceActiveWarning.classList.toggle('aafp_display-none', !pinPoolCheckBox.checked);
  COMMON_FORM_ELEMENTS.ceAddPinNumber.classList.toggle('aafp_display-none', !pinPoolCheckBox.checked);

  if( pinPoolCheckBox.checked && !hasPinPool && pins.some( pin => pin.validate === '0' ) ) {
    const awsData = {
      cardGroupId: cardGroup.cardGroupId!,
      askFor,
      action: PIN_POOL_ACTIONS.ADDPOOL
    }

    const { statusCode } = await PostPinPool(awsData);
    if ( statusCode === 200 ) {
      const poolType = askFor === 1 ? 'Pin' : 'Vehicle';
      showToast('aafp_toast', `${poolType} Pool has been updated`);
      setTimeout(() => {
        location.reload();
      }, 2000);
    }
  }

  COMMON_FORM_ELEMENTS.ceAddPinNumber.addEventListener('click', () => {
    PinPoolModalDisplay(COMMON_FORM_ELEMENTS.ceAddModal, 'Add Vehicle Pin', 'add');
  });

  if ( !pinPoolCheckBox.checked && pins.some( pin => pin.validate !== '0' ) ) {
    WarningModalControl(askFor, data);
  }  
};